import React from 'react';
import './list-display.scss';
import { Tooltip } from 'antd';

export interface List {
    header: string;
    data: any[];
}

export interface ListDisplayComponentProps {
    lists: List[];
    ItemRenderer?: React.FC<{ item: string }>;
}

const ListDisplay: React.FC<ListDisplayComponentProps> = ({ lists, ItemRenderer }) => {
    return (
        <div className="list-display-container">
            <div className="list-display-header">
                {lists.map(list => (
                    <div key={list.header} className="list-header">
                        {list.header}
                    </div>
                ))}
            </div>
            <div className="list-display-content">
                {lists.map(list=> (
                    <div key={list.header} className="list">
                        {list.data.map((item) => (
                            <div key={item} className="list-item">
                                <Tooltip overlayClassName={'list-item-tooltip'} title={item} placement={'bottomLeft'}
                                         align={{
                                             offset: [0, -5],
                                         }}>
                                    <span>{ItemRenderer ? <ItemRenderer item={item} /> : item}</span>
                                </Tooltip>
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ListDisplay;